<!-- Main Content (Hidden When an Item is Selected) -->
<div class="flex flex-1 overflow-hidden" *ngIf="!hasSelectedItems">
  <!-- Left Content -->
  <div class="flex-1 flex flex-col items-center justify-center p-8">
    <img
      alt="Illustration of a computer screen with documents"
      class="mb-4"
      height="200"
      [src]="imageSrc"
      width="200"
    />
    <h2 class="text-2xl font-semibold mb-2">Links Related Items to Get Started</h2>
    <p class="text-center text-gray-600 mb-4">
      Linking Items to this Related Items makes it easier for you and your team to find relevant information throughout bUIIDXV
    </p>
    <button class="bg-[#E76B3F] text-white px-4 py-2 rounded" (click)="toggleRelatedItems()">
      Link Related Items
    </button>
  </div>
</div>

<!-- Sidebar (Hidden/Shown Based on Toggle) -->
<div
  class="fixed top-0 right-0 w-1/4 h-full bg-white shadow-md overflow-y-auto transition-transform mt-[67px]"
  [ngClass]="{ 'translate-x-0': isSidebarOpen, 'translate-x-full': !isSidebarOpen }"
>
  <div class="p-4 border-b flex justify-between items-center">
    <label class="text-[24px] font-semibold sticky z-50 top-0">Links Related Items</label>
    <button (click)="toggleRelatedItems()" class="text-gray-600 hover:text-black">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="p-4 space-y-2">
    <div *ngFor="let item of relatedItems" class="p-2 border rounded hover:bg-gray-100 cursor-pointer" (click)="addItem(item)">
      <p class="text-sm text-gray-600">Date: {{ item.date }}</p>
      <p class="text-sm">{{ item.location }}</p>
    </div>
  </div>
</div>

<!-- Table (Always Visible Once an Item is Selected) -->
<div class="container mx-auto mt-10" *ngIf="hasSelectedItems">
  <label class="text-[1rem] !text-[#21252A] font-semibold mb-4">Link Related Items</label>
  <div class="overflow-x-auto">
    <table class="min-w-full bg-white border border-gray-300">
      <thead>
        <tr class="bg-[#D9D9D9] text-[#21252A] uppercase text-[18px] leading-normal">
          <th class="py-3 px-6 text-left">Item Type</th>
          <th class="py-3 px-6 text-left">Item Name</th>
          <th class="py-3 px-6 text-left">Item Date</th>
          <th class="py-3 px-6 text-left">Notes</th>
          <th class="py-3 px-6 text-center">Action</th>
        </tr>
      </thead>
      <tbody class="text-gray-600 text-sm font-light">
        <tr *ngFor="let item of items; let i = index" class="border-b border-gray-200 hover:bg-gray-100">
          <td class="py-3 px-6 text-left whitespace-nowrap">{{ item.type }}</td>
          <td class="py-3 px-6 text-left">{{ item.location }}</td>
          <td class="py-3 px-6 text-left">{{ item.date }}</td>
          <td class="py-3 px-6 text-left">{{ item.notes }}</td>
          <td class="py-3 px-6 text-center">
            <mat-icon class="text-red-500 cursor-pointer" (click)="removeItem(i)">delete</mat-icon>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
